function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "36",
  height: "33",
  viewBox: "0 0 36 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M13.693 18.525v14.288H.5v-11.28c0-6.107.73-10.527 2.188-13.262C4.601 4.626 7.631 1.868 11.778 0l3.008 4.785c-2.506 1.048-4.352 2.62-5.537 4.717-1.185 2.05-1.846 5.058-1.982 9.023h6.425zm21.192 0v14.288H21.69v-11.28c0-6.107.73-10.527 2.188-13.262C25.793 4.626 28.824 1.868 32.97 0l3.008 4.785c-2.507 1.048-4.353 2.62-5.538 4.717-1.184 2.05-1.845 5.058-1.982 9.023h6.426z",
  fill: "currentColor"
})));